import { Component, Input, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ChangeTypeEnum,
  Program,
  RecordChange,
  Result,
  Scenario,
} from '@model';

@Component({
  selector: 'optima-scenario-history',
  templateUrl: './scenario-history.component.html',
  styleUrls: ['./scenario-history.component.scss'],
})
export class ScenarioHistoryComponent implements OnChanges {
  @Input() history: RecordChange[];
  @Input() scenario: Scenario;
  @Input() results: Result[];
  batchChanges: RecordChange[];
  breakingChanges: RecordChange[];
  lastRan: Date;
  programs: Program[];

  constructor(private route: ActivatedRoute) {
    this.breakingChanges = [];
    this.batchChanges = [];
  }

  ngOnChanges(): void {
    this.lastRan = new Date(this.scenario?.runStartedOn);
    this.batchChanges = this.newBatchChanges();
    this.breakingChanges = this.newBreakingChanges();
    const allPrograms = [
      ...this.route.snapshot.data['scenarioView'][0],
      ...this.route.snapshot.data['scenarioView'][1],
    ];
    this.programs = allPrograms.filter(
      program =>
        this.scenario.programs.custom.includes(program.id) ||
        this.scenario.programs.standard.includes(program.id),
    );
    this.programs = this.programs.filter(program =>
      this.batchChanges.find(record => record.newValue === program.id),
    );
    this.batchChanges.map(record => {
      const match: Program = this.programs.find(
        program => record.newValue === program.id,
      );
      if (match) {
        record.newValue = match.programName;
        return record;
      }
      return null;
    });
  }
  newBreakingChanges(): RecordChange[] {
    if (this.scenario.results.length > 0 && this.history) {
      return this.history.filter(change => {
        return (
          change.changeType != ChangeTypeEnum.SILENT_CHANGE &&
          change.changeType != ChangeTypeEnum.BATCH_UPDATE &&
          new Date(change.timestamp) > this.lastRan
        );
      });
    }
    return [];
  }

  newBatchChanges(): RecordChange[] {
    if (this.scenario.results.length > 0 && this.history) {
      return this.history.filter(change => {
        return (
          change.changeType == ChangeTypeEnum.BATCH_UPDATE &&
          new Date(change.timestamp) > this.lastRan
        );
      });
    }
    return [];
  }
}
